export default __webpack_public_path__ + "static/media/TOR-1N.9694b408.png";